<template>
  <div>
    <div class="content">
      <!--项目详情-->
      <div class="order__itemBox" >
        <div class="storeList flex_center radius5">
          <div class="storeList__img itemList__img"><img :src="service_data.thumb_frist" alt=""></div>
          <div class="storeList__content">
            <div>{{service_data.title}}</div>
            <div class="col_999 fs_12 mb_5 one">{{service_data.desc}}</div>
            <div class="itemList_price fs_12" v-if="member_total==1"><span>¥{{service_data.tech_price?service_data.tech_price:service_data.price}}</span>{{service_data.tech_itemtime?service_data.tech_itemtime:service_data.itemtime}}分钟/次</div>
            <div class="itemList_price fs_12" v-else><span>¥{{service_data.price}}起</span>{{service_data.itemtime}}分钟/次</div>
          </div>
        </div>
      </div>
      <!--表单-->
      <van-cell-group>
        <van-cell title="是否多人同行" center value-class="bookOrder__switch">
          <van-switch  @change="manypeople()" v-model="more_checked" active-color="#45B9BC" size="26px"/>
        </van-cell>
        <van-cell title="选择人数" is-link  value-class="bookOrder__value" v-if="more_checked===true"  :value="member_total+'人'"  @click="perNum_list_picker = true">
          <!-- <select name="" id="select_perNum">
            <option v-for="(item,index) in perNum_list" :key="index" :value="item.id">{{item.number}}</option>
          </select> -->
        </van-cell>
        <van-cell title="预约时长"   value-class="bookOrder__value" is-link=""   :value="select_service_time+'分钟'"  @click="service_time_picker = true">
          <!-- <select name="" id="select_duration" v-model="select_service_time">
            <option v-for="(item,index) in duration__list" :key="index" :value="item">{{item}}</option>
          </select> -->

        </van-cell>
        <van-cell  @click="selectStore()" append title="门店选择" is-link :value="select_store!=''?select_store.storename:'请选择门店'" value-class="bookOrder__value" />
        <van-cell  @click="selectTime()" title="预约时间" is-link :value="select_start_time?select_start_time.datetime:'请选择时间'" value-class="bookOrder__value" />
        <van-cell  @click="selectTech()" v-for=" (total_1,index) in member_total" :key="index" title="选择技师" is-link :value="select_tech!=''?select_tech[index]['name']:'请选择技师'" value-class="bookOrder__value" />
        <van-cell title="联系人" value-class="bookOrder__value bookOrder__input">
          <input type="text" placeholder="请输入用户名" v-model="realname">
        </van-cell>
        <van-cell title="手机号" value-class="bookOrder__value bookOrder__input">
          <input type="tel" placeholder="请输入手机号码" v-model="mobile">
        </van-cell>
        <template v-if="coupon_total>0">
             <template v-if="select_coupon!=''">
              <van-cell @click="selectCoupon()" title="代金券" is-link value-class="">
                <div class="coupon__bg">¥{{select_coupon.coupon_price}}</div>
              </van-cell>
            </template>
            <template v-else>
              <van-cell @click="selectCoupon()" title="代金券" is-link value-class="">
                <div ><span class="coupon_total">{{coupon_total}}</span></div>
              </van-cell>
            </template>
        </template>

        <van-cell center value-class="bookOrder__switch" title-class="large__title">
          <template slot="title">
            <span class="custom-title">余额支付</span>
            <span class="col_E97620 fs_12">余额（{{member.credit2}}）元</span>
          </template>
          <van-switch @change="open_balance()" v-model="balance_open" active-color="#45B9BC" size="26px"/>
        </van-cell>

      </van-cell-group>
      <!-- <div class="hint__box flex_center"><img src="/static/img/icon_hint.png" alt=""><span>您已成功预约技师，请等待技师确认。</span></div> -->
    </div>

    <!--底部-->
    <div class="flex bookFooter">
      <div class="bookFooter__priceBox">实付：<span>¥{{price}}</span></div>
      <div class="bookBtn" @click="pay()">立即预约</div>
    </div>
  <van-popup v-model="perNum_list_picker" position="bottom">
    <van-picker    show-toolbar    :columns="perNum_list"      @cancel="perNum_list_picker = false"    @confirm="select_perNum"  />
  </van-popup>
  <van-popup v-model="service_time_picker" position="bottom">
    <van-picker    show-toolbar    :columns="timelist"      @cancel="service_time_picker = false"    @confirm="select_timelist"  />
  </van-popup>
  </div>
</template>

<script>
  export default {
    name: "bookOrder",
    data(){
      return{
        use:1,//可否下单
        store_id:0,
        tech_id:0,
        service_id:0,
        realname:'',
        mobile:'',
        select_tech:[

        ],
        select_store:[],
        select_service_time:'',
        select_start_time:[],
        select_coupon:[],
        coupon_total:0,
        price:0,
        member_total:1,
        member:[],
        //项目列表
        service_data: [],
        more_checked:false,   //随行人数开关
        //选择人数
        perNum_list:[],
        //选择时长
        timelist:[],
        balance_open:false,  //余额支付开关


        value: '',
        service_time_picker: false,
        perNum_list_picker:false,
      }
    },
    beforeRouteLeave(to, from, next){
      if (to.path === "/itemDetails") {
        //清除缓存
        sessionStorage.removeItem("order");
        next()
      }else {
        next()
      }
    },
    created(){
      this.store_id =  this.$route.query.store_id?this.$route.query.store_id:0;
      this.tech_id =  this.$route.query.tech_id?this.$route.query.tech_id:0;
      this.service_id  = this.$route.query.service_id?this.$route.query.service_id:0;
      if(this.service_id==0){
          this.$toast("请选择服务项目");return;
      }

      //获取缓存
      var order_session = JSON.parse(sessionStorage.getItem("order"));
      if(order_session){
        this.realname = order_session.realname;
        this.mobile = order_session.mobile;
        this.select_service_time = order_session.select_service_time;
        this.member_total=order_session.member_total;
        this.select_tech = order_session.select_tech;
        this.select_coupon = order_session.select_coupon;
        this.more_checked=order_session.more_checked;   //随行人数开关
        this.balance_open=order_session.balance_open;  //余额支付开关
        this.service_time_picker= order_session.service_time_picker;
        this.perNum_list_picker=order_session.perNum_list_picker;
        this.select_start_time = order_session.select_start_time;
      }
      this.get_order();
    },

    methods:{

      //获取下单页面
     get_order(){
      this.axios({
          url: this.api.order.place_order,
          data:{
            service_id:this.service_id,
            store_id:this.store_id,
            tech_id:this.tech_id,
            member_total:this.member_total,
            service_time:this.select_service_time
          }
      }).then((res) => {
          if (res.error === 0) {
            this.service_data = res.service;
            this.price = res.price;
            this.select_store = res.store;
            this.select_tech = res.tech;
            this.timelist = res.service_time_list;
            this.select_service_time = res.service_time;
            this.coupon_total = res.member_coupon.coupon_total;
            this.member = res.member;
            this.select_start_time = res.start_time;
            this.perNum_list = res.perNum_list;
            this.member_total  =res.member_total;
            if(this.member.credit2>0){  //余额大于0 默认开启余额抵扣
                this.balance_open = true
            }
            this.edit_start_time();
            this.coupon_use_price();
            this.open_balance();
          }

      })

     },
     //开启多人
     manypeople(){
       if(this.more_checked){
         this.member_total = 2;
       }else{
         this.member_total = 1;
       }
       //修改参数
       this.store_id = 0;
       this.tech_id = 0;
      this.select_coupon = [];
      this.balance_open = false;
       //修改缓存
        var order  = JSON.parse(sessionStorage.getItem("order"));
        if(order){
           order['select_tech'] = [];
           order['select_coupon'] = [];
           order['balance_open'] = false;
           order['member_total'] = this.member_total;
          sessionStorage.setItem('order',JSON.stringify(order));
        }

       this.get_order();
     },
     //修改服务开始时间
     edit_start_time(){
       //获取缓存
      var order_session = JSON.parse(sessionStorage.getItem("order"));
       if(order_session){
           if(order_session.select_start_time){
            if(order_session.select_start_time.strtotime>this.select_start_time.strtotime){
              this.select_start_time = order_session.select_start_time;
            }

           }
       }

     },
     //是否使用优惠券
     coupon_use_price(){
        if(this.select_coupon){
          if(this.select_coupon.coupon_price>0){
            console.log(this.price);
               var new_price = this.price-this.select_coupon.coupon_price;
               if(new_price<0){
                  this.price = 0;
               }else{
                 this.price = new_price
               }
          }
        }
     },
     //是否开启余额抵扣
     open_balance(){
       this.axios({
            url: this.api.order.balance_open,
            data:{
              service_id:this.service_id,
              store_id:this.store_id,
              tech_id:this.tech_id,
              member_total:this.member_total,
              service_time:this.select_service_time,
              balance_open:this.balance_open,
            }
        }).then((res) => {
            if (res.error === 0) {
               this.price = res.price
               this.coupon_use_price();
            }

        })
     },
     select_timelist(value) {
      this.select_service_time = value;
      this.service_time_picker = false;
      this.get_order();
    },
     select_perNum(value) {//选择人数
      this.member_total = value;
      this.perNum_list_picker = false;
      this.get_order();

    },
    //选择门店
    selectStore(){
        //修改参数
      this.tech_id = 0;
      this.select_coupon = [];
      this.balance_open = false;
      this.set_ordersession();
       //修改缓存
        var order  = JSON.parse(sessionStorage.getItem("order"));
        if(order){
           order['select_tech'] = [];
          order['select_coupon'] = [];
          order['balance_open'] = false;
          order['member_total'] = this.member_total;
          sessionStorage.setItem('order',JSON.stringify(order));
        }


      this.$router.push({path:'selectStore',query:{'service_id':this.service_id,'tech_id':this.tech_id,'member_total':this.member_total}});
    },
    //选择时间
    selectTime(){
      if(this.store_id==0){
         this.$toast("请先选择服务门店");
         return;
      }
      this.set_ordersession();
      this.$router.push({path:'selectTime',query:{'service_id':this.service_id,'store_id':this.store_id,'tech_id':this.tech_id,'member_total':this.member_total,'service_time':this.select_service_time,'select_time':this.select_start_time.strtotime}});
    },
    //选择技师
     selectTech(){
      if(this.store_id==0||this.select_start_time==[]){
         this.$toast("请先选择服务门店和服务时间");
         return;
      }
      this.set_ordersession();
      this.$router.push({path:'selectTech',query:{'service_id':this.service_id,'store_id':this.store_id,'member_total':this.member_total,'tech_id':this.tech_id,'service_time':this.select_service_time,'start_time':this.select_start_time.strtotime}});
    },
    selectCoupon(){
      this.set_ordersession();
      this.$router.push({path:'selectCoupon',query:{'service_id':this.service_id,'store_id':this.store_id,'member_total':this.member_total,'service_time':this.select_service_time,'tech_id':this.tech_id}});

    },
    //支付
    pay(){
       var phoneNum_reg=/^(((13[0-9]{1})|(14[0-9]{1})|(17[0-9]{1})|(15[0-3]{1})|(15[4-9]{1})|(18[0-9]{1})|(199))+\d{8})$/;   //手机号正则

       if(this.select_store==''){
          this.$toast("请选择门店");
          return;
       }
       if(this.select_tech==''){
          this.$toast("请选择技师");
          return;
       }
       if(this.select_start_time==''){
          this.$toast("请选择服务时间");
          return;
       }
       if(this.realname==''){
          this.$toast("请输入联系人");
          return;
       }
       if(this.mobile==''){
          this.$toast("请输入手机");
          return;
       }
      //  if (!phoneNum_reg.test(this.mobile)) {
      //     this.$toast('手机号格式不正确');
      //     return false
      //   }
       var order_data = {
              service_id:this.service_id,
              store_id:this.store_id,
              tech_id:this.tech_id,
              member_total:this.member_total,
              service_time:this.select_service_time,
              balance_open:this.balance_open,
              realname:this.realname,
              mobile:this.mobile
            }
        order_data['start_time']  =  this.select_start_time.strtotime;
        if(this.select_coupon!=''){
            order_data['coupon_id'] = this.select_coupon.coupon.id || '';

        }


        this.axios({
            url: this.api.order.create_order,
            data:order_data
        }).then((res) => {
          var that  = this;
            if (res.error === 0) {
              if(res.status == 1){//已使用余额抵扣全部扣完
                  this.$toast({
                    message:"下单成功",
                    duration:1000,
                    onClose:function(){
                      that.$router.push({path:'order',query:{}});
                    }
                  });
              }else{  //调用微信支付
                  console.log('调用微信支付');
                  this.wx.wxPay({
                     url:this.api.wxpay.AppoinTment,
                     data:{
                       id:res.id,
                       ordersn:res.ordersn
                     }
                  },()=>{
                    this.$toast({
                        type:'success',
                        message:"支付成功",
                        duration:2500,
                    });
                    setTimeout(()=>{
                      that.$router.push({path:'order',query:{}});
                    },2500);
                  },()=>{

                    that.$toast({
                      type:'fail',
                      message:"取消支付",
                      duration:2500,
                    });
                    setTimeout(()=>{
                      that.$router.push({path:'order',query:{status:0}});
                    },2500);
                  });

              }
          }

        });


    },





    //设置缓存
    set_ordersession(){
        var order_session = {
          use:this.use,//可否下单
          store_id:this.store_id,
          tech_id:this.tech_id,
          service_id:this.service_id,
          realname:this.realname,
          mobile:this.mobile,
          member_total:this.member_total,
          more_checked:this.more_checked,   //随行人数开关
          balance_open:this.balance_open,  //余额支付开关
          service_time_picker: this.service_time_picker,
          perNum_list_picker:this.perNum_list_picker,
          select_service_time:this.select_service_time,
          select_tech:this.select_tech,
          select_coupon:this.select_coupon,
          select_start_time:this.select_start_time,
        }
         sessionStorage.setItem('order', JSON.stringify(order_session));
    }
    }
  }
</script>

<style scoped>
  @import '../../assets/css/store.css';   /*门店样式*/
  @import '../../assets/css/item.css';   /*服务项目*/
  .coupon_total{
    background: #45b9bc;
    color: white;
    padding: .1rem .3rem;
    border-radius: 100%;
    font-size: 0.5rem;
  }
  .order__itemBox{
    background: #45B9BC;
    padding: .75rem .5rem;
  }
  .storeList{
    margin-bottom: 0;
  }
  .van-cell{
    font-size: .7rem;
  }
  .bookOrder__switch{
    display: flex;
    justify-content: flex-end;
  }
  .bookOrder__value{
    text-align: left;
    color: #333;
    flex: 2;
    -webkit-flex: 2;
    -webkit-box-flex: 2;
  }
  .bookOrder__value select{
    width: 100%;
    height: 100%;
    border: solid 1px #ddd;
    appearance:none;
    -moz-appearance:none;
    -webkit-appearance:none;
    padding-right: 14px;
    border:0;
  }
  select::-ms-expand { display: none; }
  .bookOrder__input{
    margin-left: -.5rem;
  }
  .custom-title{
    margin-right: .15rem;
  }
  .coupon__bg{
    background: url("/static/img/coupon_bg.png") no-repeat center;
    background-size: 100% 100%;
    display: inline-block;
    padding: 0 .5rem;
    color: #fff;
    text-align: center;
  }
  .large__title{
    flex: 2;
    -webkit-flex: 2;
    -webkit-box-flex: 2;
  }
  .hint__box{
    padding: .5rem .75rem;
    font-size: .6rem;
    color: #999;
  }
  .hint__box img{
    width: .8rem;
    margin-right: .25rem;
  }

  /*底部*/
  .bookFooter{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 2.5rem;
    background: #fff;
    font-size: .6rem;
  }
  .bookFooter>div{
    width: 50%;
  }
  .bookFooter__priceBox{
    font-size: .6rem;
    color: #666;
    padding: 0 .75rem;
  }
  .bookFooter__priceBox span{
    color: #EF7A2F;
    font-size: .9rem;
    font-weight: 500;
  }
  .bookBtn{
    text-align: center;
    font-size: .9rem;
    color: #fff;
    background: #45B9BC;
    line-height: 2.5rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/book/bookOrder.vue